export const IconProjects = props => (
  <svg
    width={props?.size || 12}
    height={props?.size || 12}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.4 2.4a1.2 1.2 0 0 1 1.2-1.2h4.8a1.2 1.2 0 0 1 1.2 1.2v7.2a.6.6 0 0 1 0 1.2H7.8a.6.6 0 0 1-.6-.6V9a.6.6 0 0 0-.6-.6H5.4a.6.6 0 0 0-.6.6v1.2a.6.6 0 0 1-.6.6H2.4a.6.6 0 1 1 0-1.2zm1.8.6h1.2v1.2H4.2zm1.2 2.4H4.2v1.2h1.2zM6.6 3h1.2v1.2H6.6zm1.2 2.4H6.6v1.2h1.2z"
      fill="#fff"
    />
  </svg>
)

export const IconLocation = props => (
  <svg
    width={props?.size || 12}
    height={props?.size || 12}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 .629c-1.861 0-3.375 1.527-3.375 3.41 0 .638.281 1.43.69 2.22.9 1.738 2.4 3.489 2.4 3.489a.375.375 0 0 0 .57 0s1.5-1.751 2.4-3.49c.41-.79.69-1.58.69-2.219C9.375 2.156 7.862.63 6 .63m0 2a1.376 1.376 0 1 0 .001 2.75 1.376 1.376 0 0 0 0-2.75"
      fill="#fff"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.392 8.691c.407.122.742.273.973.45.15.114.26.226.26.362 0 .08-.045.152-.11.225-.105.12-.263.227-.458.327-.689.352-1.803.573-3.057.573s-2.368-.22-3.057-.573a1.6 1.6 0 0 1-.458-.327c-.064-.073-.11-.145-.11-.225 0-.136.11-.248.26-.362.232-.177.567-.328.973-.45a.375.375 0 0 0-.216-.718c-.619.186-1.1.442-1.389.724-.254.248-.378.525-.378.806 0 .35.199.7.602.993.708.512 2.13.882 3.773.882s3.065-.37 3.773-.882c.404-.292.602-.642.602-.993 0-.281-.124-.558-.378-.806-.289-.282-.77-.538-1.389-.724a.375.375 0 0 0-.216.718"
      fill="#fff"
    />
  </svg>
)

export const IconCompetitorLocation = props => (
  <svg
    width={props?.size || 12}
    height={props?.size || 12}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.399 8.197c.782.677 2.025 1.547 3.114 1.382q.172-.027.338-.085a10 10 0 0 1-.454-.663c-.41-.657-.54-1.41-.486-2.13a2.4 2.4 0 0 0-1.025.476c-.122.097-.306.024-.278-.131a1.55 1.55 0 0 1 1.427-1.258l.364-2.462c.037-.26.15-.613.468-.861.35-.268.955-.572 1.943-.662l-.045-.04c-.379-.292-1.357-.78-3.47-.459S.384 2.381.106 2.773c-.107.15-.122.339-.096.523l.454 3.08c.103.7.403 1.362.934 1.823zm1.644-4.118c.083-.058.203-.037.221.062l.006.03a.746.746 0 0 1-.62.85.74.74 0 0 1-.839-.628l-.003-.03c-.012-.102.097-.158.193-.126a1.17 1.17 0 0 0 1.04-.157zm1.862 4.433c.551.88 1.49 2.08 2.58 2.244s2.334-.703 3.114-1.382c.531-.459.831-1.12.934-1.822l.454-3.08c.026-.184.011-.374-.096-.524-.277-.392-1.074-1.147-3.187-1.468s-3.09.167-3.469.46c-.146.112-.216.288-.242.472l-.454 3.08c-.103.7-.007 1.422.368 2.02zm2.68-2.9a1.16 1.16 0 0 0-.503-.203 1.15 1.15 0 0 0-.538.045c-.096.032-.205-.025-.193-.126l.003-.03a.737.737 0 0 1 .838-.628c.404.062.681.44.621.85l-.005.03c-.02.099-.14.12-.222.061zm2.553.29c-.019.1-.139.12-.221.062a1.16 1.16 0 0 0-.503-.203 1.15 1.15 0 0 0-.538.045c-.095.032-.204-.024-.193-.125l.004-.03a.737.737 0 0 1 .838-.628c.403.061.68.44.62.849l-.005.03zm-.2 1.864a2.06 2.06 0 0 1-2.19 1.217 2.08 2.08 0 0 1-1.744-1.814c-.019-.155.167-.226.285-.125.448.39 1.005.662 1.631.755.626.094 1.24.002 1.78-.24.142-.063.3.06.236.205z"
      fill="#fff"
    />
  </svg>
)

export const IconClusters = props => (
  <svg
    width={props?.size || 12}
    height={props?.size || 12}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.494 11L8.034 1.2H9.392L7.852 11H6.494ZM2.14 8.466L2.322 7.164H10.19L10.008 8.466H2.14ZM3.484 11L5.024 1.2H6.382L4.842 11H3.484ZM2.602 5.302L2.826 4H10.694L10.47 5.302H2.602Z"
      fill="white"
    />
  </svg>
)

export const IconDeveloper = props => (
  <svg width={props?.size || 12} height={props?.size || 12} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M8.333 4.406a.3.3 0 0 0-.008-.066 2.4 2.4 0 0 0-1.258-1.55v.542a.267.267 0 0 1-.534 0v-.8a.267.267 0 0 0-.266-.266h-.534a.266.266 0 0 0-.266.266v.8a.267.267 0 0 1-.534 0V2.79a2.4 2.4 0 0 0-1.259 1.55.2.2 0 0 0-.006.066.4.4 0 0 0 .065.793h4.534a.4.4 0 0 0 .066-.793m-.466 1.326H4.133V6c0 .51.206.97.537 1.308l-.004.025v.45l1.327.59 1.34-.671v-.369l-.003-.025A1.86 1.86 0 0 0 7.867 6z"
      fill="#9D9D9D"
    />
    <path
      d="M4.4 9.734h3.201V8.166l-1.481.74a.27.27 0 0 1-.228.005l-1.49-.663zm-.532-1.57A2.9 2.9 0 0 0 2.312 9.32a.267.267 0 0 0 .222.414h1.334zM9.689 9.32a2.9 2.9 0 0 0-1.555-1.156v1.57h1.334a.267.267 0 0 0 .221-.414"
      fill="#9D9D9D"
    />
  </svg>
)
